// import { ThemeName } from '../types';

export const CHANGE_ROLE = 'CHANGE_ROLE';
export const ISBLOCKING = 'ISBLOCKING';
export const PATH_NAME = 'PATH_NAME';

export const changeRole = (role: any) => ({
    type: CHANGE_ROLE,
    payload: role ,
});
export const isBlocking = (isblocking: any) => ({
    type: ISBLOCKING,
    payload: isblocking ,
});
export const pathName = (pathname: any) => ({
    type: PATH_NAME,
    payload: pathname ,
});

